import Model, { attr } from '@ember-data/model';
import dateUtils from 'donor-elf-web/lib/date-utils';

export default class JournalSummaryDecisionModel extends Model {
  @attr('string') declare journalGoalId: string;
  @attr('date-only') declare decisionDate: Date;
  @attr('boolean') declare yesNo: boolean;
  @attr('number') amount?: number;
  @attr('date-only') firstGiftDate?: Date;

  get decisionDateString() {
    return dateUtils.serializeToDateOnly(this.decisionDate);
  }

  get firstGiftDateString(): string | undefined {
    return dateUtils.serializeToDateOnly(this.firstGiftDate);
  }
}
